import React from "react";
import { useSelector } from 'react-redux';

function About() {
   const eventData = useSelector((state) => state.event.eventData);
    const community = eventData.community;
    const sliders = eventData.community.sliders;
    console.log("community",community)
  return (
    <div
      class="about-area position-relative overflow-hidden space"
      id="about-sec"
    >
      <div class="container">
        <div class="row">
          <div class="col-xl-7">
            <div class="img-box3">
              <div class="img1">
                <img src={sliders[0].imageKey} alt="About" />
              </div>
              <div class="img2">
                <img src={sliders[1].imageKey} alt="About" />
              </div>
              <div class="img3 movingX">
                <img src={sliders[2].imageKey} alt="About" />
              </div>
            </div>
          </div>
          <div class="col-xl-5">
            <div class="ps-xl-4">
              <div class="title-area mb-20 pe-xxl-5 me-xxl-5">
                <span class="sub-title style1 ">{community.Heading}</span>
                <h2 class="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                {community.Subheading}
                </h2>
              </div>
              <p class="sec-text mb-30">
               {community.Description}
              </p>
              
              <div class="about-item-wrap">
              {community.communitydata[0] && (
                <div class="about-item style2">
                {/* <div class="about-item_img">
                  <img src="assets/img/icon/about_1_1.svg" alt="" />
                </div> */}
                <div class="about-item_centent">
                  <h5 class="box-title">{community.communitydata[0].name}</h5>
                  <p class="about-item_text">
                    {community.communitydata[0].address}
                  </p>
                </div>
              </div>
              )}
                
                {community.communitydata[1] && (
 <div class="about-item style2">
 {/* <div class="about-item_img">
   <img src="assets/img/icon/about_1_2.svg" alt="" />
 </div> */}
 <div class="about-item_centent">
   <h5 class="box-title">{community.communitydata[1].name}</h5>
   <p class="about-item_text">
   {community.communitydata[1].address}
   </p>
 </div>
</div>
                )}
               
                {community.communitydata[2] && (
  <div class="about-item style2">
    <div class="about-item_centent">
      <h5 class="box-title">{community.communitydata[2].name}</h5>
      <p class="about-item_text">
        {community.communitydata[2].address}
      </p>
    </div>
  </div>
)}

              </div>
              <div class="mt-35">
                <a href="/community" class="th-btn style3 th-icon">
                  View
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="shape-mockup movingX d-none d-xxl-block"
          data-top="0%"
          data-left="-20%"
        >
          <img src="assets/img/shape/shape_2_1.png" alt="shape" />
        </div>
        <div
          class="shape-mockup jump d-none d-xxl-block"
          data-top="20%"
          data-right="-15%"
        >
          <img src="assets/img/shape/shape_2_2.png" alt="shape" />
        </div>
        <div
          class="shape-mockup spin d-none d-xxl-block"
          data-bottom="18%"
          data-left="-17%"
        >
          <img src="assets/img/shape/shape_2_3.png" alt="shape" />
        </div>
        <div
          class="shape-mockup movixgX d-none d-xxl-block"
          data-bottom="10%"
          data-right="-18%"
        >
          <img src="assets/img/shape/shape_2_4.png" alt="shape" />
        </div>
      </div>
      <div
        class="shape-mockup movingCar d-none d-xxl-block"
        data-bottom="0%"
        data-right="-2%"
      >
        <img src="assets/img/shape/car_1.png" alt="shape" />
      </div>
      <div
        class="shape-mockup d-none d-xxl-block"
        data-bottom="0%"
        data-right="0%"
      >
        <img src="assets/img/shape/tree_1.png" alt="shape" />
      </div>
    </div>
  );
}

export default About;
